var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("renderless-laravel-vue-pagination", {
    attrs: {
      data: _vm.data,
      limit: _vm.limit,
      "show-disabled": _vm.showDisabled,
    },
    on: { "pagination-change-page": _vm.onPaginationChangePage },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({
            data,
            limit,
            computed,
            prevButtonEvents,
            nextButtonEvents,
            pageButtonEvents,
          }) {
            return computed.total > computed.perPage
              ? _c(
                  "ul",
                  { staticClass: "pagination" },
                  [
                    computed.prevPageUrl || _vm.showDisabled
                      ? _c(
                          "li",
                          {
                            staticClass: "page-item pagination-prev-nav",
                            class: { disabled: !computed.prevPageUrl },
                          },
                          [
                            _c(
                              "a",
                              _vm._g(
                                {
                                  staticClass: "page-link",
                                  attrs: {
                                    href: "#",
                                    "aria-label": "Previous",
                                    tabindex: !computed.prevPageUrl && -1,
                                  },
                                },
                                prevButtonEvents
                              ),
                              [
                                _vm._t("prev-nav", function () {
                                  return [
                                    _c(
                                      "svg",
                                      {
                                        staticStyle: {
                                          height: "1.5em",
                                          width: "1.5em",
                                        },
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 24 24",
                                          height: "24",
                                          width: "24",
                                          fill: "currentColor",
                                          "aria-hidden": "true",
                                          focusable: "false",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-uppercase d-none d-md-inline",
                                      },
                                      [_vm._v(_vm._s(_vm.__("Previous")))]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(computed.pageRange, function (page, key) {
                      return _c(
                        "li",
                        {
                          key: key,
                          staticClass: "page-item",
                          class: [
                            { active: page == computed.currentPage },
                            page === "..."
                              ? "pagination-range"
                              : "pagination-page-nav",
                          ],
                        },
                        [
                          page === "..."
                            ? _c("span", { staticClass: "page-link" }, [
                                _vm._v(_vm._s(page)),
                              ])
                            : _c(
                                "a",
                                _vm._g(
                                  {
                                    staticClass: "page-link",
                                    attrs: { href: "#" },
                                  },
                                  pageButtonEvents(page)
                                ),
                                [_vm._v(_vm._s(page))]
                              ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    computed.nextPageUrl || _vm.showDisabled
                      ? _c(
                          "li",
                          {
                            staticClass: "page-item pagination-next-nav",
                            class: { disabled: !computed.nextPageUrl },
                          },
                          [
                            _c(
                              "a",
                              _vm._g(
                                {
                                  staticClass: "page-link",
                                  attrs: {
                                    href: "#",
                                    "aria-label": "Next",
                                    tabindex: !computed.nextPageUrl && -1,
                                  },
                                },
                                nextButtonEvents
                              ),
                              [
                                _vm._t("next-nav", function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-uppercase d-none d-md-inline",
                                      },
                                      [_vm._v(_vm._s(_vm.__("Next")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        staticStyle: {
                                          height: "1.5em",
                                          width: "1.5em",
                                        },
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 24 24",
                                          height: "24",
                                          width: "24",
                                          fill: "currentColor",
                                          "aria-hidden": "true",
                                          focusable: "false",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e()
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }